import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-feature-page-shell',
    templateUrl: './feature-page-shell.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class FeaturePageShellComponent {
    @Input() avoidShellHeader = true;
    @Input() contentClass = '';
}
